export default "__VITE_ASSET__CgIPP0Tn__";